export default __webpack_public_path__ + "static/media/flyback_controller_ac_psr.8177b9ce.svg";